<script lang="ts" setup>
import { PROTOCOL1, PROTOCOL2, PROTOCOL3 } from '~/utils/constant';
</script>

<template>
  <div class="container flex h-[60px] flex-row items-center justify-between">
    <img class="h-12" src="~/assets/image/logo@2x.png" alt="logo" />
    <div class="ml-[175px] flex flex-col justify-center text-left">
      <div class="mb-2 flex items-center justify-between font-bold">
        <NuxtLink
          class="!text-subtitle hover:!text-info"
          to="https://www.hetao101.com"
          >核桃编程</NuxtLink
        >
        <a-popover :overlay-inner-style="{ padding: '16px' }">
          <template #content>
            <div class="mx-auto mt-[2px] flex flex-row items-center">
              <img
                class="mr-2 h-[42px] w-[42px]"
                src="~/assets/image/logo_hetao.png"
                alt="logo"
              />
              <div>
                <div class="font-bold leading-[20px] text-title">
                  核桃OJ学生交流群
                </div>
                <div class="mt-[2px] leading-[20px] text-subtitle">
                  群号:628876678
                </div>
              </div>
            </div>
            <a-divider class="!my-[18px]" dashed></a-divider>
            <div class="mx-[9px] mb-[5px] mt-[2px]">
              <img
                class="h-[168px] w-[168px]"
                src="~/assets/image/home/qq.png"
                alt="qq群"
              />
            </div>
          </template>
          <div class="cursor-pointer text-subtitle">QQ群</div>
        </a-popover>
        <NuxtLink class="!text-subtitle hover:!text-info" :to="PROTOCOL1"
          >用户协议</NuxtLink
        >
        <NuxtLink class="!text-subtitle hover:!text-info" :to="PROTOCOL2"
          >隐私政策</NuxtLink
        >
        <NuxtLink class="!text-subtitle hover:!text-info" :to="PROTOCOL3"
          >儿童隐私政策</NuxtLink
        >
        <div class="text-subtitle">
          <span>意见反馈：</span>
          <NuxtLink
            class="!text-subtitle hover:!text-info"
            to="mailto:oj@hetao101.com"
            >oj@hetao101.com</NuxtLink
          >
        </div>
      </div>
      <div
        class="flex items-center justify-start gap-0 text-xs text-colorTextQuaternary"
      >
        <span>Copyright © 2024-2025 广州如棠科技有限公司</span>

        <a-divider type="vertical"></a-divider>

        <a
          href="https://beian.mps.gov.cn/#/query/webSearch?code=44010602013590"
          rel="noreferrer"
          target="_blank"
          class="!text-colorTextQuaternary hover:!text-info"
          >粤公网安备44010602013590号</a
        >

        <a
          href="https://beian.miit.gov.cn/#/Integrated/index"
          rel="noreferrer"
          target="_blank"
          class="!text-colorTextQuaternary hover:!text-info"
          >粤ICP备2022046115号-11</a
        >

        <a-divider type="vertical"></a-divider>

        <span>增值电信业务经营许可证：粤B2-20221557</span>
      </div>
    </div>
  </div>
</template>
